<template>
    <div class="pipeline-stepper">
        <div class="pipeline-stepper__pipeline">
            <PipelineStep
                v-for="(step, index) in stepsToDisplay"
                :key="index"
                :step="step"
                :selected="selectedStepId === step.id"
                :finished="isFinished(step)"
                :isFirst="index === 0"
                :isLast="index === stepsToDisplay.length - 1"
                :canEdit="canEdit"
                @update="handleUpdate"
            />
        </div>
    </div>
</template>
<script>
import PipelineStep from 'vcomponents/overview/PipelineStepper/PipelineStep.vue';

export default {
    components: {
        PipelineStep,
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
        selectedStep: {
            type: Number,
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            maxDisplayedSteps: 8,
        };
    },
    computed: {
        selectedStepId() {
            return this.steps[this.selectedStep].id;
        },
        hasPagination() {
            return this.steps.length > this.maxDisplayedSteps;
        },
        stepsToDisplay() {
            if (!this.hasPagination) {
                return this.steps;
            }

            const surplusStart = 3; // the first index where surplus can begin
            const surplusEnd = this.steps.length - 4; // the last index where surplus can end

            const indicesToKeep = new Set([
                this.selectedStep - 1, // previous step
                this.selectedStep, // current step
                this.selectedStep + 1, // next step
                this.selectedStep + 2, // next next step
                this.steps.length - 1, // last step
            ]);

            // Add steps to result
            const result = this.steps
                .map((step, index) => {
                    if (
                        index === 0 ||
                        index === this.steps.length - 1 ||
                        indicesToKeep.has(index)
                    ) {
                        return step;
                    } else if (index >= surplusStart && index <= surplusEnd) {
                        // Group surplus steps
                        return [step];
                    } else {
                        return step;
                    }
                })
                .reduce((acc, step, index) => {
                    // Log only the condition and action
                    if (index > 0 && Array.isArray(step) && Array.isArray(acc[acc.length - 1])) {
                        acc[acc.length - 1].push(...step); // Merge current step into the last item of accumulator
                    } else {
                        acc.push(step); // Add current step to accumulator
                    }
                    return acc;
                }, []);

            return result;
        },
    },
    methods: {
        isFinished(item) {
            if (Array.isArray(item)) {
                return item.every((step) => this.isFinished(step));
            }
            const currentStepIndex = this.steps.findIndex((step) => step.id === item.id);
            return this.selectedStep > currentStepIndex;
        },
        handleUpdate(step) {
            this.$emit('update', step);
        },
    },
};
</script>
<style lang="scss" scoped>
.pipeline-stepper {
    align-items: center;
    display: flex;
    flex: 1;
    gap: var(--spacing-1);
    min-width: 0;

    &__pipeline {
        border-radius: 2px;
        display: flex;
        flex: 1;
        gap: 2px;
        overflow: hidden;
    }
}
</style>
